export enum AutomaticInviteType {
  OnRegister = 'registration',
  AcceptRetrigger = 'accept-match',
  LoginRetrigger = 'login',
  ManualTrigger = 'manual',
  Update = 'update',
  TwoWeek = 'two-week',
  NewPotentialJobs = 'new-potential-jobs',
  Reactivation = 'reactivation',
}
